/**
 * Created by Pavel Kozhin on 28/09/15.
 */
define([
    'jQuery',
    'underscore',
    'library/fcse-dropdown/dropdown',
    'library/fcse-request/multiRequestHandler'
], function($, _, Dropdown, MultiRequestHandler) {

    /**
     * ZooverReviews component
     * @param element
     * @param ajaxRoute
     * @constructor
     */
    var ZooverReviews = function (element, ajaxRoute) {
        this.element = element;
        this.ajaxRoute = ajaxRoute;

        var defaultOptions = {
            itemsSelector: '[data-fcse-role="testimonial-items"]',
            sortingDropdownSelector: '#testimonials-sorting',
            testimonialListContentSelector: '[data-fcse-role="testimoniallist-content"]',
            isLoadingClass: 'is-loading'
        };

        this.routeOptions = $(defaultOptions.itemsSelector, this.element).data('route-options');
        this.routeOptions['requestId'] = this.element.data('fcse-request-id');
        this.reviewsRequestHandler = null;
        this.options = defaultOptions;

        this.init();
    };

    ZooverReviews.prototype = {
        /**
         * Initializer
         */
        init: function () {
            var self = this;

            this.reviewsRequestHandler = new MultiRequestHandler();
            this.sortingDropDown = new Dropdown(this.options.sortingDropdownSelector, {});
            this.sortingDropDown.on('change', $.proxy(this._onSortingChange, this));

            this.reviewsRequestHandler.on('success', function(data) {
                $(self.options.testimonialListContentSelector, self.element).removeClass(self.options.isLoadingClass);

                if (data && data.state == 'OK' && data.html) {
                    $(self.options.testimonialListContentSelector, self.element).html(data.html);
                }
            });

            // Initialize paging
            $(this.element).on('click', '[data-fcse-role="pagination"] [data-page]',
                $.proxy(this._onPaginationClick, this));
        },

        /**
         * Sorting change handler
         * @private
         */
        _onSortingChange: function() {
            if (this.routeOptions['sorting'] != this.sortingDropDown.value) {
                this.routeOptions['sorting'] = this.sortingDropDown.value;
                // Resetting page when sorted
                this.routeOptions['page'] = 1;
                $(this.options.testimonialListContentSelector, this.element).addClass(this.options.isLoadingClass);

                this.reviewsRequestHandler.cancel(this.ajaxRoute);
                this.reviewsRequestHandler.send(this.ajaxRoute, this.routeOptions, this.routeOptions);
            }
        },

        /**
         * Click handler for pagination link
         * @param event
         * @private
         */
        _onPaginationClick: function(event){
            var page = $(event.currentTarget).attr('data-page');
            if (this.routeOptions['page'] != page) {
                this.routeOptions['page'] = page;
                $(this.options.testimonialListContentSelector, this.element).addClass(this.options.isLoadingClass);
                $('body,html').scrollTop($(this.element).offset().top);
                this.reviewsRequestHandler.cancel(this.ajaxRoute);
                this.reviewsRequestHandler.send(this.ajaxRoute, {}, this.routeOptions);
            }
        }
    };

    return ZooverReviews;
});


// WEBPACK FOOTER //
// ./src/Allt/FrontendBundle/Resources/assets/components/zooverreviews/zooverReviews.js